import { enqueueIndexCall } from '@/api/indexQueuer';
import type { SymbolKey } from '@/entities/symbol';
import { http } from '@/services/http';
import { toQueryParams } from '@/utils/toQueryParams';

export type FeedSymbol = {
  alias: string;
  currency: string;
  title: string;
  units: string;
  periodAbs: string;
};

export const fetchSymbolData = async (code: SymbolKey, date: string): Promise<FeedSymbol> => {
  const params = toQueryParams({
    to: date.split('T')[0],
    size: 1,
    metadata: true,
    ...code
  });
  const responseData = await enqueueIndexCall(() =>
    http.data
      .get(`/index${params}`, { headers: { Accept: 'application/json' } })
      .then(({ data }) => data)
  );

  return {
    alias: responseData?.[0]?.metadata?.Alias,
    currency: responseData?.[0]?.metadata?.Currency,
    title: responseData?.[0]?.metadata?.Title,
    units: responseData?.[0]?.metadata?.Units,
    periodAbs: responseData?.[0]?.values?.PeriodAbs
  };
};
